import * as angular from 'angular';

import { WidgetWithErrors } from '../';
import { LogbookTableConfiguration } from './LogbookTable.configuration';
import { IwidgetIntervalHelperService } from '../../services';
import { LogbookEntrySortOrder, DateOrder, IBindable, WidgetValuesReadConfiguration, RowSpacing, LogbookWidgetFilters, IValueViewModel, GroupDisplayName, TrendLogbookEntriesType } from '../../models/';
import { Helper } from '../../common/';
import { LogbookTableReadMode } from './LogbookTableReadMode';
import { logbookTableWidgetDefinition as definition } from './logbookTable.definition';

export class LogbookTableWidget extends WidgetWithErrors {
    allowedGroupGuidList: string[] = [];
    baseType = definition.baseType;
    col = 0;
    configuration: LogbookTableConfiguration;
    exportFormats = ['csv'];
    exportToCsv: () => angular.IPromise<any>;
    group = definition.group;
    guid: string;
    hasExtendedProperties = true;
    hasImage = definition.hasImage;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    prefilters: LogbookWidgetFilters;
    row = 0;
    series?: { alarms: any[]; configuration: any; missing: boolean; viewModel: IValueViewModel }[];
    sizeX = 6;
    sizeY = 18;
    sortingOrder = definition.sortingOrder;
    title = definition.title;
    type = definition.type;

    constructor(
        private _$q: angular.IQService,
        intervalHelper: IwidgetIntervalHelperService
    ) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = {
            alignedOn: 0,
            dateFormat: '',
            filters: {
                includeChildren: true,
                seriesGuids: [],
                groupGuids: [],
                categories: [],
                groupTypes: [],
                severities: [],
                sortBy: LogbookEntrySortOrder.Date,
                dateOrder: DateOrder.Increasing,
                isBoundToGroup: false,
                isAlwaysShow: false
            },
            groupNameDisplayed: GroupDisplayName.UniqueName,
            hasCategories: true,
            hasDateModified: false,
            hasDescription: true,
            hasDuration: false,
            hasGroup: undefined, // for legacy
            hasId: true,
            hasPreviousIncluded: false,
            hasSeverity: true,
            hasUser: true,
            isEndDateIncluded: false,
            launchTask: true,
            maxItems: undefined,
            maxTotalItems: 100,
            maxPeriod: {} as any,
            minPeriod: {} as any,
            nameConfiguration: {
                hasName: true,
                hasGroupName: false,
                hasShortComment: false,
                hasUnit: false,
                hasValueType: false,
                hasAggregationMode: false
            },
            readMode: LogbookTableReadMode.ByTimeStamp,
            rowSpacing: RowSpacing.Normal,
            series: [],
            taskOptionsOverride: { includeDependent: true },
            logbookEntriesShownType: TrendLogbookEntriesType.Default
        };
    }

    getSeriesListAsync(): angular.IPromise<IBindable[]> {
        //TODO relative path
        const result = this.configuration.series.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                relativePath: '', //d.relativePath,
                isBoundToGroup: d.isBoundToGroup
            };
        });
        return this._$q.when(result);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = false;//this.configuration.isQualityVisible;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = null;
                const config = this.createConfiguration(data, aggregation, hasQuality, hasMissingRanges, hasContext, hasTendency, hasTarget);
                config.hasAlarm = !!this.configuration.series?.filter(s => s.hasAlarm).length;
                return config;
            });
    }
}